import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TicketsComponent } from './tickets.component';
import { SharedModule } from '@shared/shared.module';
import { ComponentsModule } from '@components/components.module';
import { DialogsModule } from '@routes/dialogs/dialogs.module';
import { TicketsRoutingModule } from '@routes/tickets/tickets-routing.module';
import { TicketViewsComponent } from '@routes/tickets/ticket-views/ticket-views.component';
import { TicketEditModule } from '@routes/tickets/ticket-edit/ticket-edit.module';

@NgModule({
  declarations: [
    TicketsComponent,
    TicketViewsComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    ComponentsModule,
    DialogsModule,
    TicketsRoutingModule,
    TicketEditModule,
  ],
  exports: [
    TicketsComponent,
    TicketViewsComponent,
  ]
})
export class TicketsModule {
}

